import { render, staticRenderFns } from "./Detect.vue?vue&type=template&id=1c06830d&"
import script from "./Detect.vue?vue&type=script&lang=js&"
export * from "./Detect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports